<template>
  <div>
    <footer class="footer">
      <div class="container-fluid d-flex flex-wrap justify-content-between">
        <nav>
          <ul class="footer-menu">
            <li></li>
          </ul>
        </nav>
        <div class="copyright">
          {{ $t('vie.Lay.ContentFooter.smartCopy') }}
          <a
            href="https://aplicacionescorporativas.com/"
            target="_blank"
            rel="noopener"
          >
            {{ $t('vie.Lay.ContentFooter.corporativeApplications') }}</a
          >.
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
